<template>
    <div>
        <BrowseTrWorkFileUI/>
    </div>
</template>

<script>
import BrowseTrWorkFileUI from '../../../components/tax/taxRollWorkFile/BrowseTrWorkFile.vue';

export default {
  name: 'BrowseTrWorkFile',
  data() {
    return {};
  },
  components: {
    BrowseTrWorkFileUI,
  },
};
</script>
